import { ListType } from "../../../../shared/Enums/Enums";
import { MenuComponent } from "../../../../shared/screen-components/CommonMenuComponent/CommonMenuComponent";
import { AgGridComponent } from "../../../../shared/screen-components/AgGridComponent/AgGridComponent";
import ExcelStyles from "./TemplateExcelView.module.css";

const TemplateExcelView = () => {
  return (
    <div className={ExcelStyles.templateDiv}>
      <MenuComponent menuType={ListType.Templates} />
      <AgGridComponent
        pagination={false}
        height="100vh"
      />
    </div>
  );
};

export default TemplateExcelView;
